<template>
  <div class="appeal-list-panel">
    <el-card>
      <div slot="header" class="clearfix">
        <span>诉求查询</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="3">
          <el-select v-model="query.state" placeholder="状态" clearable style="width: 100%;">
            <el-option v-for="item in stateOptions" :key="item.statusCd" :label="item.name" :value="item.statusCd" />
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="query.communityId" filterable placeholder="请选择小区" clearable style="width: 100%;">
            <el-option v-for="item in communityOptions" :key="item.communityId" :label="item.name"
              :value="item.communityId" />
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-select v-model="query.typeCd" placeholder="分类" clearable style="width: 100%;">
            <el-option v-for="item in typeOptions" :key="item.typeCd" :label="item.typeName" :value="item.typeCd" />
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-date-picker v-model="query.startTime" type="datetime" placeholder="开始时间"
            value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;" />
        </el-col>
        <el-col :span="3">
          <el-date-picker v-model="query.endTime" type="datetime" placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;" />
        </el-col>
        <el-col v-if="isAdmin" :span="3">
          <el-select v-model="query.areaId" placeholder="社区" clearable style="width: 100%;">
            <el-option v-for="item in areaOptions" :key="item.areaId" :label="item.areaName" :value="item.areaId" />
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-input v-model="query.keyword" placeholder="标题/内容" clearable />
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="handleSearch">查询</el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card>
      <div slot="header" class="clearfix">
        <span>诉求列表</span>
      </div>
      <el-table v-loading="loading" :data="appealList" border style="width: 100%">
        <el-table-column prop="title" label="标题" align="center" show-overflow-tooltip />
        <el-table-column label="状态" align="center" width="110">
          <template slot-scope="scope">
            <el-tag size="mini" :style="getStateTagStyle(scope.row.state)">
              {{ scope.row.stateName }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="communityName" label="小区" align="center" />
        <el-table-column prop="typeName" label="分类" align="center" />
        <el-table-column label="提交人" align="center" width="120">
          <template slot-scope="scope">
            {{ scope.row.isAnonymous === '1' ? '匿名' : scope.row.createUserName }}
          </template>
        </el-table-column>
        <el-table-column prop="tel" label="联系电话" align="center" />
        <el-table-column prop="createTime" label="提交时间" align="center" :formatter="formatDateTime" />
        <el-table-column label="操作" align="center" width="280">
          <template slot-scope="scope">
            <el-button size="mini" @click="goDetail(scope.row)">详情</el-button>
            <el-button v-if="scope.row.state === 'W'" size="mini" type="primary" @click="goDetail(scope.row, 'reply')">回复</el-button>
            <el-button v-if="scope.row.state === 'R'" size="mini" type="warning" @click="goDetail(scope.row, 'audit')">审核撤销</el-button>
            <el-button v-if="isAdmin" size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page.sync="page.current" :page-sizes="[10, 20, 30, 50]" :page-size="page.size"
        :total="page.total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </el-card>
  </div>
</template>

<script>
import { listAreaAppeals, deleteAreaAppeal } from '@/api/community/areaAppealApi'
import { listAreaAppealTypes } from '@/api/community/areaAppealTypeApi'
import { getDict, getMyEnteredCommunitys } from '@/api/community/communityApi'
import { listAreas } from '@/api/community/areaApi'
import { listCommunitys } from '@/api/community/communityManageApi'
import { dateFormat, timeFormat } from '@/utils/dateUtil'

export default {
  name: 'AreaAppealListPanel',
  data() {
    return {
      loading: false,
      stateOptions: [],
      communityOptions: [],
      typeOptions: [],
      areaOptions: [],
      appealList: [],
      query: {
        state: '',
        communityId: '',
        typeCd: '',
        areaId: '',
        keyword: '',
        startTime: '',
        endTime: ''
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  computed: {
    isAdmin() {
      const role = localStorage.getItem('hc_role') || ''
      return role.indexOf('admin') > -1 || role.indexOf('ROLE_ADMIN') > -1
    }
  },
  created() {
    this.loadStateDict()
    this.loadTypes()
    this.loadMyCommunities()
    if (this.isAdmin) {
      this.loadAreas()
    }
    this.loadData()
  },
  methods: {
    formatQueryDateTime(date) {
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      const h = String(date.getHours()).padStart(2, '0')
      const min = String(date.getMinutes()).padStart(2, '0')
      const s = String(date.getSeconds()).padStart(2, '0')
      return `${y}-${m}-${d} ${h}:${min}:${s}`
    },
    getStateTagStyle(state) {
      const styles = {
        W: { color: '#FF9800', backgroundColor: 'rgba(255, 152, 0, 0.1)', border: '1px solid rgba(255, 152, 0, 0.2)' },
        C: { color: '#4CAF50', backgroundColor: 'rgba(76, 175, 80, 0.1)', border: '1px solid rgba(76, 175, 80, 0.2)' },
        R: { color: '#FFC107', backgroundColor: 'rgba(255, 193, 7, 0.1)', border: '1px solid rgba(255, 193, 7, 0.2)' },
        X: { color: '#9E9E9E', backgroundColor: 'rgba(158, 158, 158, 0.1)', border: '1px solid rgba(158, 158, 158, 0.2)' }
      }
      return styles[state] || styles.X
    },
    loadStateDict() {
      getDict('c_area_appeal', 'state').then(res => {
        this.stateOptions = Array.isArray(res) ? res : (res.data || [])
      }).catch(() => {})
    },
    loadTypes() {
      listAreaAppealTypes({ page: 1, row: 500 }).then(res => {
        this.typeOptions = res.data || []
      }).catch(() => {})
    },
    loadMyCommunities() {
      getMyEnteredCommunitys({ page: 1, row: 500 }).then(res => {
        const list = res.communitys || []
        this.communityOptions = list
        // admin 若未查询到加入的小区，兜底加载全部小区
        if (this.isAdmin && list.length === 0) {
          this.loadAllCommunitys()
        }
      }).catch(() => {
        if (this.isAdmin) {
          this.loadAllCommunitys()
        }
      })
    },
    loadAllCommunitys() {
      listCommunitys({ page: 0, row: 500 }).then(res => {
        this.communityOptions = res.communitys || []
      }).catch(() => {})
    },
    loadAreas() {
      listAreas({ page: 1, row: 500 }).then(res => {
        const data = res.data || {}
        this.areaOptions = data.areas || []
      }).catch(() => {})
    },
    loadData() {
      this.loading = true
      const params = {
        page: this.page.current,
        row: this.page.size,
        state: this.query.state,
        communityId: this.query.communityId,
        typeCd: this.query.typeCd,
        keyword: this.query.keyword,
        startTime: this.query.startTime,
        endTime: this.query.endTime
      }
      if (this.isAdmin && this.query.areaId) {
        params.areaId = this.query.areaId
      }
      listAreaAppeals(params).then(res => {
        const data = res.data || {}
        this.appealList = data.appeals || []
        this.page.total = data.total || 0
        // 列表已同步（含删除/详情页返回后的刷新），通知布局页立即刷新诉求角标，不等 60 秒轮询
        window.dispatchEvent(new CustomEvent('area-appeal-changed'))
      }).catch(error => {
        this.$message.error(error.message || '获取诉求列表失败')
      }).finally(() => {
        this.loading = false
      })
    },
    handleSearch() {
      this.page.current = 1
      this.loadData()
    },
    goDetail(row, action) {
      this.$router.push(`/pages/areaAppealDetail?appealId=${row.appealId}${action ? '&action=' + action : ''}`)
    },
    formatDateTime(row, column, cellValue) {
      if (!cellValue) {
        return '-'
      }
      return dateFormat(cellValue) + ' ' + timeFormat(cellValue)
    },
    handleDelete(row) {
      this.$confirm('确认删除该诉求？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteAreaAppeal({ appealId: row.appealId }).then(() => {
          this.$message.success('删除成功')
          this.loadData()
        }).catch(error => {
          this.$message.error(error.message || '删除失败')
        })
      }).catch(() => {})
    },
    handleSizeChange(val) {
      this.page.size = val
      this.page.current = 1
      this.loadData()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.loadData()
    }
  }
}
</script>

<style lang="scss" scoped>
.appeal-list-panel {
  .el-card {
    margin-bottom: 20px;
  }

  .el-pagination {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
